import { lehtoCustomizations } from "src/tenantCustomizations/tenants/lehto/lehtoCustomizations";
import { omegakeittiotCustomizations } from "src/tenantCustomizations/tenants/omegakeittiot/omegakeittiotCustomizations";
import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import { LOCAL_CLONE_CUSTOMIZATION_NAME } from "src/tenantCustomizations/resolveTenantCustomizationName.ts";
import { salvosCustomizations } from "src/tenantCustomizations/tenants/salvos/salvosCustomizations.ts";
import { mellanoCustomizations } from "./tenants/mellano/mellanoCustomizations";
import { hawoCustomizations } from "src/tenantCustomizations/tenants/hawo/hawoCustomizations.ts";
import { demo1Customizations } from "src/tenantCustomizations/tenants/demo1/demo1Customizations.ts";
import { lumonCustomizations } from "src/tenantCustomizations/tenants/lumon/lumonCustomizations.ts";
import { devTenantCustomizations } from "src/tenantCustomizations/tenants/dev/devTenantCustomizations.ts";
import { necoCustomizations } from "src/tenantCustomizations/tenants/neco/necoCustomizations.ts";
import { ssaCustomizations } from "src/tenantCustomizations/tenants/ssa/ssaCustomizations.ts";
import { feeliaCustomizations } from "src/tenantCustomizations/tenants/feelia/feeliaCustomizations.tsx";
import { plgCustomizations } from "src/tenantCustomizations/tenants/plg/plgCustomizations.ts";
import { lapellandCustomizations } from "./tenants/lapelland/lapellandCustomizations";
import { sirmetCustomizations } from "src/tenantCustomizations/tenants/sirmet/sirmetCustomizations.ts";
import { wiivakalusteCustomizations } from "src/tenantCustomizations/tenants/wiivakaluste/wiivakalusteCustomizations.ts";
import { porinpuukalusteCustomizations } from "src/tenantCustomizations/tenants/porinpuukaluste/porinpuukalusteCustomizations.ts";
import { lipabetoniCustomizations } from "src/tenantCustomizations/tenants/lipabetoni/lipabetoniCustomizations.ts";
import { royalkalusteetCustomizations } from "src/tenantCustomizations/tenants/royalkalusteet/royalkalusteetCustomizations.ts";

const realTenantCustomizationValues: Record<string, PartialTenantCustomizations> = {
	demo1: demo1Customizations,
	lehto: lehtoCustomizations,
	omegakeittiot: omegakeittiotCustomizations,
	salvos: salvosCustomizations,
	hawo: hawoCustomizations,
	tilaelementti: hawoCustomizations,
	mellano: mellanoCustomizations,
	lumon: lumonCustomizations,
	neco: necoCustomizations,
	ssa: ssaCustomizations,
	feelia: feeliaCustomizations,
	plg: plgCustomizations,
	lapelland: lapellandCustomizations,
	sirmet: sirmetCustomizations,
	wiivakaluste: wiivakalusteCustomizations,
	porinpuukaluste: porinpuukalusteCustomizations,
	"lipa-betoni": lipabetoniCustomizations,
	royalkalusteet: royalkalusteetCustomizations,
	jloy: {},
	billing: {} // To prevent errors from legacy internal billing "tenant"
} as const;

const devTenant = import.meta.env.VITE_DEV_TENANT;
const cloneTenant = import.meta.env.VITE_CLONE_TENANT;
const cloneTenantCustomizations = cloneTenant === undefined ? undefined : realTenantCustomizationValues[cloneTenant];

export const tenantCustomizationValues: Record<string, PartialTenantCustomizations> = {
	...realTenantCustomizationValues,
	localhost: devTenant === undefined ? devTenantCustomizations : realTenantCustomizationValues[devTenant]!,
	...(cloneTenantCustomizations === undefined ? {} : { [LOCAL_CLONE_CUSTOMIZATION_NAME]: cloneTenantCustomizations }),
} as const;
